import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Nav from './nav';
import Nav2 from './nav2';
import Hero from './Hero';
import '../assets/css/style.css';
import About from './About';
import PortFolio from './PortFolio';
import Contact from './Contact';
import DIP from '../projects/dip';
import LUXTRACE from '../projects/luxtrace';
import Comidix from '../projects/comidix';
import BlockLit from '../projects/blocklit';
import MBook from '../projects/matchbook';
import Voting from '../projects/voting';
const URI = 'http://localhost:8000/';

function App() {

  return (
    <BrowserRouter>
      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path='/project/dip' element={<ProjectWrapper component={DIP} />} />
          <Route path='/project/luxtrace' element={<ProjectWrapper component={LUXTRACE} />} />
          <Route path='/project/comidix' element={<ProjectWrapper component={Comidix} />} />
          <Route path='/project/blocklit' element={<ProjectWrapper component={BlockLit} />} />
          <Route path='/project/mbook' element={<ProjectWrapper component={MBook} />} />
          <Route path='/project/voting' element={<ProjectWrapper component={Voting} />} />




        </Routes>
      </main>
    </BrowserRouter>
  );
}

const Home = () => (
  <>
    <div id="page" className="s-pagewrap ss-home">
      <Nav />
      <Hero />
    </div>
    <About />
    <PortFolio />
    <Contact URI={URI} />
  </>
);
const ProjectWrapper = ({ component: ProjectComponent }) => (
  <>
    <div id="page" className="s-pagewrap ss-home">
      <Nav2 />
    </div>
    <ProjectComponent />
  </>
);


export default App;
